var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrevArrow = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0v24h24z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M13.59 6 15 7.41 10.42 12 15 16.59 13.59 18l-6-6z"
}))));
export { SvgPrevArrow as ReactComponent };
export default __webpack_public_path__ + "assets/images/prev-arrow.svg";